import { YOUTUBE_ENGAGEMENT_SUCCESS } from '../constants/actionTypes';


const INITIAL_STATE = { data: null, errors: null };

export default function ytEngagement(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case YOUTUBE_ENGAGEMENT_SUCCESS:
    
      // const parsedData = JSON.parse(action.payload.data)
     
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}